import * as React from "react";
import MuiTextField from "@mui/material/TextField";
import { ChangeEventHandler, useState } from "react";
import Props from "./index.d";
import ordinaryColors from "themes/ordinaryColors";
import { hasNonLatinCharacters } from "utils/hasNonLatinCharacters";
import { translations } from "translations";
import { useGetUserInfo } from "lib/userInfo";
import { showNoteOnCarefulInputConditionally } from "pages/UploadCertificate/utils";

const TextField: React.FC<Props> = (props) => {
  const userInfo = useGetUserInfo();
  const isPlatformOperator = userInfo?.role === "PLATFORM_OPERATOR";
  const {
    title,

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    data: { state, setstate, onBlur, updateValue, setNull, setAndSave },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    placeholder = "placeholder",
    disabled,
    testId,
    errors,
    isRequiredField,
    errorManager,
    className,
    isUnit,
    hideLabel,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ...rest
  } = props;
  const [showNoteOnCarefulInput, setShowNoteOnCarefulInput] = useState(false);

  const change: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (e) => {
    const value = e.target.value;

    if (value === null) {
      if (setNull) {
        setNull();
      } else {
        setstate("");
      }
    } else {
      if (typeof value === "string") setstate(value);
    }
  };

  // Add custom validation for non-Latin characters
  const customErrors: string[] = [];
  if (state && hasNonLatinCharacters(state)) {
    const errorMessage = translations.pages.certificateUpload.errorMessages.nonLatinCharacters;
    customErrors.push(errorMessage);
  }

  const errorManagerRes = errorManager({
    errorJoiner: (errors) => {
      return [...errors, ...customErrors].join(", ");
    },
  });

  const hasCustomErrors = customErrors.length > 0;
  const hasAnyErrors = errorManagerRes.error || hasCustomErrors;

  return (
    <>
      {showNoteOnCarefulInputConditionally({ condition: !isPlatformOperator && showNoteOnCarefulInput })}
      <MuiTextField
        sx={{
          height: "35px",
          padding: "0px",
          marginBottom: hasAnyErrors ? "27px" : "14px",
          borderRadius: "0px",
          "& .MuiFormHelperText-root": {
            marginLeft: "0px",
            fontSize: "12px",
            color: ordinaryColors.error,
          },
          " .MuiOutlinedInput-notchedOutline": {
            borderWidth: "0px",
          },
          "& .MuiOutlinedInput-input": {
            padding: "0.5rem 0.75rem",
            width: "100%",
          },
          "& .MuiOutlinedInput-root": {
            borderRadius: "0px",
            border: hasAnyErrors && !isUnit ? "1px solid rgba(214, 40, 57, 1) " : "1px solid #9E9E9E66",
            backgroundColor: hasAnyErrors ? "rgba(211, 47, 47, 0.02)" : "transparent",
            padding: "0px",
            "& fieldset": {
              borderRadius: "0px",
            },
          },
        }}
        aria-label={title}
        onFocus={() => setShowNoteOnCarefulInput(true)}
        onBlur={() => {
          onBlur();
          setShowNoteOnCarefulInput(false);
        }}
        value={state || ""}
        onChange={change}
        disabled={isPlatformOperator ? false : props.disabled}
        label={hideLabel ? undefined : title}
        className={className}
        data-testid={testId}
        // showRemoveIcon={!isRequiredField}
        required={isRequiredField}
        InputProps={{ sx: { height: "40px" } }}
        error={hasAnyErrors}
        helperText={
          hasCustomErrors && !isUnit
            ? customErrors.join(", ")
            : errorManagerRes.error && !isUnit
            ? errorManagerRes.helperText
            : ""
        }
      />
    </>
  );
};

export default TextField;
